import Carousel from '../components/Carousel';
import Slider from '../components/Slider';
import { $ } from '../util/DOM';

const getLinkHtml = (el) => {
  const qs = el.getAttribute('data-link-content');
  if (!qs) {
    return '';
  }
  const content = el.querySelector(qs);
  if (!content) {
    return '';
  }
  return content.innerHTML;
};

const sliderControlComponents = {
  arrows: (slider) => $.render('div', {
    className: 'slider-controls__arrows',
    children: [
      $.render('button', {
        type: 'button',
        className: 'prev',
        attrs: { 'aria-label': 'Voltar slide' },
        innerHTML: /* html */ `
        <svg width="9" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 1.25199C8.99973 1.58377 8.87945 1.90186 8.66559 2.13633L2.83474 8.53693C2.65826 8.73061 2.51825 8.96056 2.42274 9.21365C2.32722 9.46673 2.27806 9.73799 2.27806 10.0119C2.27806 10.2859 2.32722 10.5571 2.42274 10.8102C2.51825 11.0633 2.65826 11.2933 2.83474 11.4869L8.65799 17.8792C8.86566 18.1152 8.98057 18.4313 8.97797 18.7595C8.97537 19.0876 8.85548 19.4014 8.64411 19.6335C8.43274 19.8655 8.1468 19.9971 7.84789 20C7.54898 20.0028 7.26101 19.8767 7.046 19.6487L1.22275 13.2615C0.439753 12.4003 0 11.2332 0 10.0165C0 8.7998 0.439753 7.63279 1.22275 6.77159L7.0536 0.366817C7.21303 0.191688 7.41621 0.0724106 7.63743 0.0240773C7.85864 -0.024256 8.08794 0.000527255 8.29631 0.0952911C8.50469 0.190055 8.68278 0.35054 8.80804 0.55644C8.9333 0.762339 9.0001 1.0044 9 1.25199Z" fill="black"/>
        </svg>
        `,
        events: {
          click: () => {
            slider.goPrev();
          },
        },
      }),
      $.render('button', {
        type: 'button',
        className: 'next',
        attrs: { 'aria-label': 'Avançar slide' },
        innerHTML: /* html */ ` <svg width="9" height="20" viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M0 18.7522C0.000266085 18.4204 0.12055 18.1023 0.334407 17.8678L6.16526 11.4672C6.34174 11.2736 6.48175 11.0436 6.57726 10.7905C6.67278 10.5374 6.72194 10.2662 6.72194 9.99223C6.72194 9.71829 6.67278 9.44703 6.57726 9.19394C6.48175 8.94086 6.34174 8.71091 6.16526 8.51723L0.342007 2.1208C0.134343 1.88478 0.0194346 1.56867 0.022032 1.24055C0.0246295 0.912428 0.144525 0.598556 0.355895 0.366533C0.567265 0.134509 0.853197 0.00289857 1.15211 4.7307e-05C1.45102 -0.00280395 1.73899 0.123332 1.954 0.351289L7.77725 6.74271C8.56025 7.60391 9 8.77093 9 9.98765C9 11.2044 8.56025 12.3714 7.77725 13.2326L1.9464 19.6332C1.78719 19.8081 1.58436 19.9272 1.36351 19.9757C1.14265 20.0242 0.91366 19.9998 0.705439 19.9055C0.497217 19.8113 0.319093 19.6514 0.193545 19.4462C0.0679956 19.2409 0.00064776 18.9994 0 18.7522Z" fill="black"/> </svg> `,
        events: {
          click: () => {
            slider.goNext();
          },
        },
      }),
    ],
  }),
  counters: (slider) => {
    const children = slider.children.map((el, i) => $.render('button', {
      type: 'button',
      textContent: i + 1,
      attrs: { 'aria-label': `Ver o slide ${i + 1}` },
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__counters',
      children,
    });
  },
  links: (slider) => {
    const children = slider.children.map((el, i) => $.render('div', {
      innerHTML: getLinkHtml(el),
      tabindex: '-1',
      events: { click: () => slider.goTo(i) },
    }));

    slider.on('render', () => {
      children.forEach((btn, btnIndex) => {
        if (btnIndex === slider.index) {
          btn.classList.add('is-active');
        } else {
          btn.classList.remove('is-active');
        }
      });
    });

    return $.render('div', {
      className: 'slider-controls__links',
      children,
    });
  },
};

const generateControls = (slider, keys) => keys.map((key) => {
  if (!(key in sliderControlComponents)) {
    // eslint-disable-next-line no-console
    console.warn(`Opção de controle inválida: ${key}. As opções disponíveis são ${
      Object.keys(sliderControlComponents).join(', ')
    }`);
    return null;
  }
  return sliderControlComponents[key](slider);
});

const setSliderControls = (slider, controlOptions) => {
  if (!controlOptions) {
    return;
  }
  const controlKeys = controlOptions.trim().split(' ');
  if (!controlKeys.length) {
    return;
  }

  const container = $.render('div', {
    className: 'slider-controls__container',
    children: generateControls(slider, controlKeys),
  });

  slider.container.insertAdjacentElement('afterEnd', container);
};

const createSlider = (container, type) => {
  const play = container.hasAttribute('data-play');
  const interval = container.getAttribute('data-interval') || 3000;
  const height = container.getAttribute('data-height');
  const controls = container.getAttribute('data-controls');

  const slider = (
    type === 'carousel'
      ? new Carousel(container, { interval })
      : new Slider(container, { interval })
  );

  if (play) {
    slider
      .on('mouseover', () => slider.pause())
      .on('mouseout', () => slider.play())
      .play();
  }

  if (height) {
    slider.container.style.height = height;
  }

  if (controls) {
    setSliderControls(slider, controls);
  }

  return slider;
};

const createCarousel = (container) => {
  createSlider(container, 'carousel');
};

const initSliders = () => {
  $('.slider').forEach(createSlider);
  $('.carousel').forEach(createCarousel);
};

export default initSliders;
